import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const APConnectBannerCell: StyleRule = ({ theme }) => ({
    width: '100%',
    margin: 0,

    [theme.screen.laptop]: {
        width: 'inherit',
        marginLeft: pxToRem(10),
        marginRight: pxToRem(10),
        gridColumnStart: 1,
        gridColumnEnd: 4,
    },
});
